import React from 'react';

import { FormattedMessage, InjectedIntl, injectIntl } from 'react-intl';

import { gridSize } from '@atlaskit/theme';

import SelectField from 'src/components/select-field';
import { selectControlStyles } from 'src/styles/select';

import { FILTER_KIND } from './constants';
import * as filtersStyles from './filters.styles';
import messages from './privacy-filter.i18n';

export type Props = {
  intl: InjectedIntl;
  privacy?: FILTER_KIND.PRIVATE | FILTER_KIND.PUBLIC;
  onFilterChange: (filter: {
    privacy?: FILTER_KIND.PRIVATE | FILTER_KIND.PUBLIC;
  }) => void;
};

const options = [
  {
    label: <FormattedMessage {...messages.privateLabel} />,
    value: FILTER_KIND.PRIVATE,
  },
  {
    label: <FormattedMessage {...messages.publicLabel} />,
    value: FILTER_KIND.PUBLIC,
  },
];

const getSelected = (option?: FILTER_KIND.PRIVATE | FILTER_KIND.PUBLIC) =>
  options.find(o => o.value === option) || null;

class PrivacyFilter extends React.Component<Props> {
  // @ts-ignore TODO: fix noImplicitAny error here
  handleFilterChange = e => {
    this.props.onFilterChange({ privacy: e ? e.value : null });
  };

  render() {
    const selectedOption = getSelected(this.props.privacy);

    return (
      <div>
        <SelectField
          inputId="privacy-filter"
          onChange={this.handleFilterChange}
          isClearable
          placeholder={this.props.intl.formatMessage(messages.typeLabel)}
          options={options}
          value={selectedOption}
          styles={{
            control: (css, state) => ({
              ...css,
              ...filtersStyles.subtleSelector(css, state),
              ...selectControlStyles,
              minWidth: selectedOption ? gridSize() * 14 : gridSize() * 12,
            }),
            menu: css => ({
              ...css,
              minWidth: gridSize() * 14,
            }),
            placeholder: css => ({
              ...css,
              ...filtersStyles.nothingSelectedColor(),
            }),
          }}
        />
      </div>
    );
  }
}

export default injectIntl(PrivacyFilter);
